import React from 'react';
import { FormMode } from '../../../enums/form-mode';
import CreateReport from './create';

export default function EditReport() {
  return <CreateReport mode={FormMode.edit} />;
}
